@let item = result();

<div
  (click)="openProductDetailView(item)"
  class="relative flex items-center justify-center gap-2 w-full cursor-pointer"
>
  @if (item?.thumbnail | media; as thumbnail) {
    @if (item?.thumbnail && thumbnail) {
      <span
        class="flex items-center justify-center min-w-8 min-h-8 text-center content-center bg-surface"
      >
        <img [src]="thumbnail" class="max-w-[32px] max-h-[32px]" alt="thumbnail" />
      </span>
    }
  } @else {
    <span
      class="flex items-center justify-center rounded-md min-w-8 min-h-8 text-center content-center bg-surface-tertiary group-hover:bg-surface-quaternary"
    >
      <soft-icon name="fa-solid fa-box" class="text-sm"></soft-icon>
    </span>
  }

  <div class="flex flex-row w-full text-start items-center gap-3">
    <span class="text-sm font-semibold truncate flex-1">
      {{ item?.name }}
    </span>

    <div class="flex gap-2 items-center shrink-0">
      <span class="text-xs text-light font-mono opacity-70">
        {{ item?.number }}
      </span>

      @if (item?.ean) {
        <span
          class="text-[10px] py-0.5 px-1.5 rounded bg-surface-secondary text-light font-mono border border-border"
        >
          {{ item?.ean }}
        </span>
      }
    </div>
  </div>
</div>
